import { ReportReasonCatalogSystem } from 'constants/report-reason'

import { api } from './api'

export const generateAlertsFromSearchParams = ({
  searchParams,
  reportReason,
}: {
  searchParams: Record<string, string | Array<string> | undefined>
  reportReason: ReportReasonCatalogSystem | undefined
}) =>
  api.post('/admin/alert_generators/execute', {
    item_search_params: searchParams,
    report_reason_code: reportReason,
  })
